"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Web3Multicall3Plugin_multicall;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Multicall3Plugin = void 0;
const web3_1 = require("web3");
const web3_multicall3_base_1 = require("../web3-multicall3.base");
const multicall3_abi_js_1 = require("../constants/multicall3.abi.js");
const config_constants_js_1 = require("../constants/config.constants.js");
class Web3Multicall3Plugin extends web3_1.Web3PluginBase {
    constructor(address = config_constants_js_1.DefaultAddress) {
        super();
        this.pluginNamespace = 'multicall';
        _Web3Multicall3Plugin_multicall.set(this, void 0);
        const contract = new web3_1.Contract(multicall3_abi_js_1.Multicall3Abi, address);
        __classPrivateFieldSet(this, _Web3Multicall3Plugin_multicall, new web3_multicall3_base_1.BaseWeb3Multicall3(contract), "f");
        this.aggregate3 = __classPrivateFieldGet(this, _Web3Multicall3Plugin_multicall, "f").aggregate3.bind(__classPrivateFieldGet(this, _Web3Multicall3Plugin_multicall, "f"));
    }
    link(ctx) {
        super.link(ctx);
        __classPrivateFieldGet(this, _Web3Multicall3Plugin_multicall, "f").contract.link(ctx);
    }
}
exports.Web3Multicall3Plugin = Web3Multicall3Plugin;
_Web3Multicall3Plugin_multicall = new WeakMap();
